import React, { Component, RefObject } from "react";
import { RiskDataManager } from "./dataProp";
import { TSData, Frame, RiskColorMap } from "./type";

import Scene from "./Scene";

import "./index.css";

type Props = {
  data: Frame[];
  risk: TSData;
  color: RiskColorMap;
  setCurrentVideoTime: (currentTime: number) => void;
};

type State = {
  containerX: number;
  containerW: number;
  containerH: number;
  containerPadding: number[];
  displayScenes: number;
  thumbnailRatio: number;
  frames: Frame[];
  scenes: Frame[][];
};

export default class FrameBrowser extends Component<Props, State> {
  containerDom: RefObject<HTMLDivElement> = React.createRef();
  constructor(props: Props) {
    super(props);
    this.state = {
      containerX: 200,
      containerH: 500,
      containerW: 500,
      containerPadding: [40, 0, 120, 0], // [l, b, r, t]
      displayScenes: 4,
      thumbnailRatio: 0.2,
      frames: [],
      scenes: [],
    };
  }

  componentDidMount() {
    const DOM = this.containerDom.current as HTMLDivElement;
    const [
      containerLeft,
      containerBottom,
      containerRight,
      containerTop,
    ] = this.state.containerPadding;
    // Init container
    this.setState({
      containerW: DOM.clientWidth - containerLeft - containerRight,
      containerH: DOM.clientHeight - containerBottom - containerTop,
    });
  }

  static getDerivedStateFromProps(nextProps: Props, prevState: State) {
    const inputData = nextProps.data || [];
    if (inputData === prevState.frames) return null;
    const {
      containerW,
      containerH,
      containerX,
      containerPadding,
      displayScenes,
    } = prevState;
    const sceneId = [];
    const scenes = [];
    const thumbnailWidth = containerX - containerPadding[0];
    const thumbnailHeight = containerH / displayScenes;
    inputData.forEach((frame) => {
      // Mapping frames to container coordination
      const x = frame.value[0];
      frame.value[0] =
        x > 1 ? x : x * (containerW - thumbnailWidth) + containerX;
      // frame.value[1] = y > 1 ? y : y * containerH;
      frame.value[1] = (frame.scene + 1) * thumbnailHeight;
      frame.size[0] = thumbnailHeight * 0.8;
      frame.size[1] = thumbnailHeight * 0.8;
      // Group frames into scenes
      let i = 0;
      let isInScenes = false;
      for (; i < sceneId.length; i++) {
        if (sceneId[i] === frame.scene) {
          isInScenes = true;
          break;
        }
      }
      if (!isInScenes) {
        sceneId.push(frame.scene);
        scenes.push([frame]);
      } else {
        scenes[i].push(frame);
      }
    });
    return {
      frames: inputData,
      scenes: scenes,
    };
  }

  render() {
    const riskDataManager = new RiskDataManager(this.props.risk);
    const scenes = this.state.scenes;
    const sceneH = this.state.containerH / this.state.displayScenes;
    const {
      scenesMaxRiskData,
      scenesMaxRiskFrame,
      frameViewData,
    } = riskDataManager.getFrameViewData(scenes);
    // TODO: integrate getFrameViewData into Scene
    const Scenes = scenes.map((scene, idx) => (
      <Scene
        key={`scene-${idx}`}
        sceneId={idx}
        thumbnail={scenesMaxRiskFrame[idx]}
        frames={frameViewData[idx]}
        riskData={this.props.risk}
        color={this.props.color}
        sceneRisk={scenesMaxRiskData[idx].sceneMaxRiskData}
        sceneX={this.state.containerX}
        sceneH={sceneH}
        callbackFn={(videoTime: number) =>
          this.props.setCurrentVideoTime(videoTime)
        }
      />
    ));
    return (
      <div
        className="frame-browser"
        style={{ width: "100%", height: "100%", overflowY: "scroll" }}
        ref={this.containerDom}
      >
        {Scenes}
      </div>
    );
  }
}
